import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab1 from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { TiMediaPlay } from "react-icons/ti";

import {
  Row,
  Col,
  Container,
  Dropdown,
  Nav,
  Tab,
  OverlayTrigger,
  Tooltip,
  Button,
  Form,
  Modal,
  Carousel as CarouselN,
} from "react-bootstrap";

import { Link } from "react-router-dom";
import user01 from "../../../assets/images/user/01.jpg";
import user02 from "../../../assets/images/user/02.jpg";
import user03 from "../../../assets/images/user/03.jpg";
import axios from "axios";
import * as moment from "moment";
import { BsDisplay } from "react-icons/bs";
import { getToken } from "../../../utils/auth";
import { useTranslation } from "react-i18next";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);
    const { t, i18n } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [userDetailSocial, setUserDetailSocial] = useState("");
  const handleUserDetailSocial = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/social-profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log(
      //   "User Detail fetched successfully social",
      //   response.data.data.userData
      // );
      let detail = response.data.data.userData;
      setEditForm({
        userBio: detail?.userProfileData?.userBio,
        city: detail?.userProfileData?.address?.city,
        country: detail?.userProfileData?.address?.country,
        birthday: detail?.userProfileData?.birthday,
      });
      setEducation(detail?.userProfileData?.education || []);
      setWorkExperience(detail?.userProfileData?.workExperience || []);
      setSocialMediaLinks(detail?.userProfileData?.socialMediaLinks || []);

      setUserDetailSocial(detail);
    } catch (error) {
      console.log("Failed Fetching User Detail", error);
    }
  };

  useEffect(() => {
    handleUserDetailSocial();
  }, []);

  const [profileInfo, setProfileInfo] = useState(true);
  const [edit, setEdit] = useState(false);
  const [editForm, setEditForm] = useState({
    userBio: "",
    city: "",
    country: "",
    birthday: "",
  });
  const [education, setEducation] = useState([]);
  const [workExperience, setWorkExperience] = useState([]);
  const [socialMediaLinks, setSocialMediaLinks] = useState([]);

  const openEdit = () => {
    setProfileInfo(false);
    setEdit(true);
  };

  const handleSave = async () => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/social-profile`,
        { ...editForm, education, workExperience, socialMediaLinks },
        
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleUserDetailSocial();
      setProfileInfo(true);
      setEdit(false);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  const handleEditFormChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleEducationChange = (index, field, value) => {
    const newEducation = [...education];
    newEducation[index][field] = value;
    setEducation(newEducation);
  };

  const addEducationEntry = () => {
    setEducation([...education, { institution: '', degree: '', fieldOfStudy: '', from: '', to: '' }]);
  };

  const removeEducationEntry = (index) => {
    const newEducation = education.filter((_, i) => i !== index);
    setEducation(newEducation);
  };

  const handleWorkExperienceChange = (index, field, value) => {
    const newWorkExperience = [...workExperience];
    newWorkExperience[index][field] = value;
    setWorkExperience(newWorkExperience);
  };

  const addWorkExperienceEntry = () => {
    setWorkExperience([...workExperience, { company: '', position: '', location: '', from: '', to: '' }]);
  };

  const removeWorkExperienceEntry = (index) => {
    const newWorkExperience = workExperience.filter((_, i) => i !== index);
    setWorkExperience(newWorkExperience);
  };

  const handleSocialMediaChange = (index, field, value) => {
    const newSocialMediaLinks = [...socialMediaLinks];
    newSocialMediaLinks[index][field] = value;
    setSocialMediaLinks(newSocialMediaLinks);
  };

  const addSocialMediaEntry = () => {
    setSocialMediaLinks([
      ...socialMediaLinks,
      { platform: "", platformLink: "" },
    ]);
  };

  const removeSocialMediaEntry = (index) => {
    const newSocialMediaLinks = socialMediaLinks.filter(
      (_, i) => i !== index
    );
    setSocialMediaLinks(newSocialMediaLinks);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab1 label={t("personalInfo")} {...a11yProps(0)} />
          <Tab1 label={t("education")} {...a11yProps(1)} />
          <Tab1 label={t("workExperience")} {...a11yProps(2)} />
          <Tab1 label={t("socialMedia")} {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {/* Personal Info */}
        <div
          style={{
            marginTop: "-10px",
            justifyContent: "flex-end",
            marginBottom: profileInfo ? "-10px" : "10px",
            display: "flex",
            width: "100%",
          }}
        >
          {profileInfo && (
            <div className="header-title">
              <Link onClick={openEdit} className="material-symbols-outlined">
                edit
              </Link>
            </div>
          )}
          {edit && (
            <div className="header-title">
              <button
                style={{ width: "100px" }}
                className="btn btn-primary d-block "
                onClick={handleSave}
              >
                {t("save")}
              </button>
            </div>
          )}
        </div>
        {profileInfo && (
          <div>
            {userDetailSocial?.userProfileData?.userBio ||
            userDetailSocial?.userProfileData?.address?.city ||
            userDetailSocial?.userProfileData?.address?.country ||
            userDetailSocial?.userProfileData?.birthday ? (
              <>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("aboutMe")}:</h6>
                  </div>
                  <div className="col-9">
                    <p className="mb-0">
                      {userDetailSocial?.userProfileData?.userBio}
                    </p>
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("city")}:</h6>
                  </div>
                  <div className="col-9">
                    <p className="mb-0">
                      {userDetailSocial?.userProfileData?.address?.city}
                    </p>
                  </div>
                </Row>
                <Row className="row mb-2">
                  <div className="col-3">
                    <h6>{t("country")}:</h6>
                  </div>
                  <div className="col-9">
                    <p className="mb-0">
                      {userDetailSocial?.userProfileData?.address?.country}
                    </p>
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("birthDate")}:</h6>
                  </div>
                  <div className="col-9">
                    <p className="mb-0">
                      {moment(
                        userDetailSocial?.userProfileData?.birthday
                      ).format("DD-MM-YYYY")}
                    </p>
                  </div>
                </Row>
              </>
            ) : (
              <span className="text">{t("pleaseAddProfileInfo")}...</span>
            )}
          </div>
        )}
        {edit && (
          <div>
            <Row className="mb-2">
              <div className="col-3">
                <h6>{t("aboutMe")}:</h6>
              </div>
              <div className="col-9">
                <p className="mb-0">
                  <Form.Control
                    type="text"
                    name="userBio"
                    className="mb-0 py-2"
                    id=""
                    placeholder="Enter bio.."
                    value={editForm.userBio}
                    onChange={(e) => {
                      handleEditFormChange(e);
                    }}
                  />
                </p>
              </div>
            </Row>
            <Row className="mb-2">
              <div className="col-3">
                <h6>{t("city")}:</h6>
              </div>
              <div className="col-9">
                <p className="mb-0">
                  <Form.Control
                    type="text"
                    name="city"
                    className="mb-0 py-2"
                    id=""
                    placeholder="Enter city.."
                    value={editForm.city}
                    onChange={(e) => {
                      handleEditFormChange(e);
                    }}
                  />
                </p>
              </div>
            </Row>
            <Row className="row mb-2">
              <div className="col-3">
                <h6>{t("country")}:</h6>
              </div>
              <div className="col-9">
                <p className="mb-0">
                  <Form.Control
                    type="text"
                    name="country"
                    className="mb-0 py-2"
                    id=""
                    placeholder="Enter country.."
                    value={editForm.country}
                    onChange={(e) => {
                      handleEditFormChange(e);
                    }}
                  />
                </p>
              </div>
            </Row>
            <Row className="mb-2">
              <div className="col-3">
                <h6>{t("birthDate")}:</h6>
              </div>
              <div className="col-9">
                <p className="mb-0">
                  <Form.Control
                    type="date"
                    name="birthday"
                    className="mb-0 py-2"
                    id=""
                    placeholder="Enter birthday.."
                    value={moment(editForm.birthday).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      handleEditFormChange(e);
                    }}
                  />
                </p>
              </div>
            </Row>
          </div>
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {/* Work & Education */}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4 className="mt-0 mb-3" style={{ display: "flex" }}>
            {t("education")}
          </h4>
          <div style={{ display: "flex" }}>
            <div className="user-img img-fluid">
              {profileInfo && (
                <div className="header-title">
                  <Link
                    onClick={openEdit}
                    className="material-symbols-outlined"
                  >
                    edit
                  </Link>
                </div>
              )}
              {edit && (
                <div className="header-title">
                  <button
                    style={{ width: "100px" }}
                    className="btn btn-primary d-block "
                    onClick={handleSave}
                  >
                    {t("save")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {profileInfo && (
          <div>
           {userDetailSocial?.userProfileData?.education.length ? (
            <ul className="suggestions-lists m-0 p-0">
              {userDetailSocial.userProfileData.education.map((edu, index) => (
                <li className="d-flex mb-4 align-items-center" key={index}>
                  <div className="user-img img-fluid">
                    <img
                      loading="lazy"
                      src="/profile.png"
                      alt="story-img"
                      className="rounded-circle avatar-40"
                    />
                  </div>
                  <div className="w-100">
                    <div className="d-flex flex-wrap justify-content-between">
                      <div className="ms-3">
                        <h6>{edu.institution}</h6>
                        <p className="mb-0">{edu.degree} in {edu.fieldOfStudy}</p>
                        <p className="mb-0">{moment(edu.from).format('MMM YYYY')} - {moment(edu.to).format('MMM YYYY')}</p>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
         ) : (
          <span className="text">{t("pleaseAddEducation")}...</span>
        )}
      </div>
    )}
         {edit && (
        <div>
          
          {education.map((edu, index) => (
            <div key={index} className="mb-4">
              <div style={{display:"flex", justifyContent:"flex-end", margin:"5px"}}>  
              <Button variant="danger" onClick={() => removeEducationEntry(index)}>{t("remove")}</Button>
              </div>
              <Row className="mb-2">
                <div className="col-3">
                  <h6>{t("institution")}:</h6>
                </div>
                <div className="col-9">
                  <Form.Control
                    type="text"
                    name="institution"
                    className="mb-0 py-2"
                    placeholder={t("institution")}
                    value={edu.institution}
                    onChange={(e) => handleEducationChange(index, 'institution', e.target.value)}
                  />
                </div>
              </Row>
              <Row className="mb-2">
                <div className="col-3">
                  <h6>{t("degree")}:</h6>
                </div>
                <div className="col-9">
                  <Form.Control
                    type="text"
                    name="degree"
                    className="mb-0 py-2"
                    placeholder={t("degree")}
                    value={edu.degree}
                    onChange={(e) => handleEducationChange(index, 'degree', e.target.value)}
                  />
                </div>
              </Row>
              <Row className="mb-2">
                <div className="col-3">
                  <h6>{t("fieldOfStudy")}:</h6>
                </div>
                <div className="col-9">
                  <Form.Control
                    type="text"
                    name="fieldOfStudy"
                    className="mb-0 py-2"
                    placeholder={t("fieldOfStudy")}
                    value={edu.fieldOfStudy}
                    onChange={(e) => handleEducationChange(index, 'fieldOfStudy', e.target.value)}
                  />
                </div>
              </Row>
              <Row className="mb-2">
                <div className="col-3">
                  <h6>{t("from")}:</h6>
                </div>
                <div className="col-9">
                  <Form.Control
                    type="date"
                    name="from"
                    className="mb-0 py-2"
                    value={moment(edu.from).format('YYYY-MM-DD')}
                    onChange={(e) => handleEducationChange(index, 'from', e.target.value)}
                    onFocus={(e) => e.target.showPicker()}
                  />
                </div>
              </Row>
              <Row className="mb-2">
                <div className="col-3">
                  <h6>{t("to")}:</h6>
                </div>
                <div className="col-9">
                  <Form.Control
                    type="date"
                    name="to"
                    className="mb-0 py-2"
                    value={moment(edu.to).format('YYYY-MM-DD')}
                    onChange={(e) => handleEducationChange(index, 'to', e.target.value)}
                    onFocus={(e) => e.target.showPicker()}
                  />
                </div>
              </Row>
              
            </div>
          ))}
          <div style={{justifyContent:"center", display:"flex"}}>
          <button onClick={addEducationEntry} className="btn btn-secondary mb-3">
            + {t("addEducation")}
          </button></div>
        </div>
      )}

      </CustomTabPanel>
           
      <CustomTabPanel value={value} index={2}>
        {/* Work Experience */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4 className="mt-0 mb-3" style={{ display: "flex" }}>
            {t("work")}
          </h4>
          <div style={{ display: "flex" }}>
            <div className="user-img img-fluid">
              {profileInfo && (
                <div className="header-title">
                  <Link onClick={openEdit} className="material-symbols-outlined">
                    edit
                  </Link>
                </div>
              )}
              {edit && (
                <div className="header-title">
                  <button
                    style={{ width: "100px" }}
                    className="btn btn-primary d-block"
                    onClick={handleSave}
                  >
                    {t("save")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {profileInfo && (
          <div>
            {userDetailSocial?.userProfileData?.workExperience.length ? (
              <ul className="suggestions-lists m-0 p-0">
                {userDetailSocial.userProfileData.workExperience.map((work, index) => (
                  <li className="d-flex mb-4 align-items-center" key={index}>
                    <div className="user-img img-fluid">
                      <img
                        loading="lazy"
                        src="/profile.png"
                        alt="story-img"
                        className="rounded-circle avatar-40"
                      />
                    </div>
                    <div className="w-100">
                      <div className="d-flex flex-wrap justify-content-between">
                        <div className="ms-3">
                          <h5>{work.company} ({work.location})</h5>
                          <p className="mb-0">{work.position}, {moment(work.from).format('MMM YYYY')} - {moment(work.to).format('MMM YYYY')}</p>
                          {/* <p className="mb-0">{moment(work.from).format('MMM YYYY')} - {moment(work.to).format('MMM YYYY')}</p> */}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <span className="text">{t("pleaseAddWorkExperience")}...</span>
            )}
          </div>
        )}
        {edit && (
          <div>
            
            {workExperience.map((work, index) => (
              <div key={index} className="mb-4">
              <div style={{display:"flex", justifyContent:"flex-end", margin:"5px"}}>  
<Button variant="danger" onClick={() => removeWorkExperienceEntry(index)}>{t("remove")}</Button>
</div>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("company")}:</h6>
                  </div>
                  <div className="col-9">
                    <Form.Control
                      type="text"
                      name="company"
                      className="mb-0 py-2"
                      placeholder={t("company")}
                      value={work.company}
                      onChange={(e) => handleWorkExperienceChange(index, 'company', e.target.value)}
                    />
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("position")}:</h6>
                  </div>
                  <div className="col-9">
                    <Form.Control
                      type="text"
                      name="position"
                      className="mb-0 py-2"
                      placeholder={t("position")}
                      value={work.position}
                      onChange={(e) => handleWorkExperienceChange(index, 'position', e.target.value)}
                    />
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("location")}:</h6>
                  </div>
                  <div className="col-9">
                    <Form.Control
                      type="text"
                      name="location"
                      className="mb-0 py-2"
                      placeholder={t("location")}
                      value={work.location}
                      onChange={(e) => handleWorkExperienceChange(index, 'location', e.target.value)}
                    />
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("from")}:</h6>
                  </div>
                  <div className="col-9">
                    <Form.Control
                      type="date"
                      name="from"
                      className="mb-0 py-2"
                      value={moment(work.from).format('YYYY-MM-DD')}
                      onChange={(e) => handleWorkExperienceChange(index, 'from', e.target.value)}
                      onFocus={(e) => e.target.showPicker()}
                    />
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("to")}:</h6>
                  </div>
                  <div className="col-9">
                    <Form.Control
                      type="date"
                      name="to"
                      className="mb-0 py-2"
                      value={moment(work.to).format('YYYY-MM-DD')}
                      onChange={(e) => handleWorkExperienceChange(index, 'to', e.target.value)}
                      onFocus={(e) => e.target.showPicker()}
                    />
                  </div>
                </Row>
              </div>
            ))}
                      <div style={{justifyContent:"center", display:"flex"}}>

            <button onClick={addWorkExperienceEntry} className="btn btn-secondary mb-3">
              + {t("addWorkExperience")}
            </button>
            </div>
          </div>
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        {/* Social Media */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4 className="mt-0 mb-3" style={{ display: "flex" }}>
            {t("socialMedia")}
          </h4>
          <div style={{ display: "flex" }}>
            <div className="user-img img-fluid">
              {profileInfo && (
                <div className="header-title">
                  <Link onClick={openEdit} className="material-symbols-outlined">
                    edit
                  </Link>
                </div>
              )}
              {edit && (
                <div className="header-title">
                  <button
                    style={{ width: "100px" }}
                    className="btn btn-primary d-block"
                    onClick={handleSave}
                  >
                    {t("save")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {profileInfo && (
          <div>
            {userDetailSocial?.userProfileData?.socialMediaLinks.length ? (
              <ul className="suggestions-lists m-0 p-0">
                {userDetailSocial.userProfileData.socialMediaLinks.map((social, index) => (
                  <li className="d-flex mb-4 align-items-center" key={index}>
                    <div className="user-img img-fluid">
                      {/* <img
                        loading="lazy"
                        src="/social.png"
                        alt="social-img"
                        className="rounded-circle avatar-40"
                      /> */}
                      <TiMediaPlay size={30}/>
                    </div>
                    <div className="w-100">
                      <div className="d-flex flex-wrap justify-content-between">
                        <div className="ms-3">
                          <h5>{social.platform}</h5>
                          <p className="mb-0">{social.platformLink}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <span className="text">{t("pleaseAddSocialMediaLinks")}...</span>
            )}
          </div>
        )}
        {edit && (
          <div>
            {socialMediaLinks.map((social, index) => (
              <div key={index} className="mb-4">
                <div style={{display:"flex", justifyContent:"flex-end", margin:"5px"}}>
                  <Button variant="danger" onClick={() => removeSocialMediaEntry(index)}>{t("remove")}</Button>
                </div>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("platform")}:</h6>
                  </div>
                  <div className="col-9">
                    <Form.Control
                      type="text"
                      name="platform"
                      className="mb-0 py-2"
                      placeholder={t("platform")}
                      value={social.platform}
                      onChange={(e) => handleSocialMediaChange(index, 'platform', e.target.value)}
                    />
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className="col-3">
                    <h6>{t("platformLink")}:</h6>
                  </div>
                  <div className="col-9">
                    <Form.Control
                      type="text"
                      name="platformLink"
                      className="mb-0 py-2"
                      placeholder={t("platformLink")}
                      value={social.platformLink}
                      onChange={(e) => handleSocialMediaChange(index, 'platformLink', e.target.value)}
                    />
                  </div>
                </Row>
              </div>
            ))}
            <Button variant="success" onClick={addSocialMediaEntry}>{t("addSocialMediaLink")}</Button>
          </div>
        )}
      </CustomTabPanel>
    </Box>
  );
}
